import { FormObject, FormStructure } from '@europrocurement/flexy-form/components';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { jsonBooleanInput } from '../types/formTypes';
import { checkFieldValue } from '../functions';

const jsonBooleanInputToFormElement: (input: jsonBooleanInput) => FormStructure = (input) => {
    const baseField: FormStructure = {
        type: input.hidden === true ? 'hidden' : input.type,
        name: input.name,
        inputlabel: input.inputlabel,
        placeholder: input.placeholder,
        defaultValue: input.defaultvalue,
        xs: input.xs,
        sm: input.sm,
        md: input.md,
        lg: input.lg,
        sx: {
            fontSize: '14px',
            marginTop: '15px',
            marginBottom: '15px',
            fontWeight: '500',
        },
        tooltip: input.tooltip,
    };

    // comportement sur rules display
    if (input.rules && input.rules.display) {
        if (input.rules.display.fieldIsEqualTo) {
            const fieldNameToWatch = input.rules.display.fieldIsEqualTo.field;
            const valueToWatch = input.rules.display.fieldIsEqualTo.value;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, valueToWatch, fieldNameToWatch);
        }
        if (input.rules.display.isTrue) {
            const fieldNameToWatch = input.rules.display.isTrue;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, true, fieldNameToWatch);
        }
        if (input.rules.display.fieldIsChecked) {
            const fieldNameToWatch = input.rules.display.fieldIsChecked;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, true, fieldNameToWatch);
        }
        if (input.rules.display.fieldIsNotChecked) {
            const fieldNameToWatch = input.rules.display.fieldIsNotChecked;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, false, fieldNameToWatch);
        }
    }

    // comportement de toute la partie disabled
    if (input.disabled) {
        if (input.disabled === true) {
            baseField.disabled = true;
        } else if (input.disabled.isFalse) {
            const fieldNameToWatch =
                typeof input.disabled.isFalse === 'string'
                    ? input.disabled.isFalse
                    : input.disabled.isFalse.field;
            baseField.disabled = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                !checkFieldValue(formContext, true, fieldNameToWatch);
        } else if (input.disabled.isValid) {
            const fieldNameToWatch =
                typeof input.disabled.isValid === 'string'
                    ? input.disabled.isValid
                    : input.disabled.isValid.field;
            baseField.disabled = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                !checkFieldValue(formContext, true, fieldNameToWatch);
        } else if (input.disabled.fieldIsNotEqualTo) {
            const fieldNameToWatch = input.disabled.fieldIsNotEqualTo.field;
            const valueToWatch = input.disabled.fieldIsNotEqualTo.value;
            baseField.disabled = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                !checkFieldValue(formContext, valueToWatch, fieldNameToWatch);
        } else if (input.disabled.fieldIsEqualTo) {
            const fieldNameToWatch = input.disabled.fieldIsEqualTo.field;
            const valueToWatch = input.disabled.fieldIsEqualTo.value;
            baseField.disabled = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, valueToWatch, fieldNameToWatch);
        } else if (input.disabled.fieldIsChecked) {
            const fieldNameToWatch = input.disabled.fieldIsChecked;
            baseField.disabled = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, true, fieldNameToWatch);
        }
    }

    return baseField;
};

export default jsonBooleanInputToFormElement;
